@if (expandable) {
  <mat-accordion multi>
    @for (item of itemList.controls; track item; let index = $index) {
      <mat-expansion-panel
        [expanded]="expandedOnCreate"
        [attr.aria-label]="'list-item-template-expandable'"
        [ngClass]="{
          '!border-b-2 !border-red-500': itemList.at(index).invalid,
        }"
      >
        <mat-expansion-panel-header>
          <div class="w-full flex justify-between items-center">
            <div class="truncate w-full flex justify-center items-center">
              <ng-template
                [ngTemplateOutlet]="headerTemplateRef"
                [ngTemplateOutletContext]="{ $implicit: item }"
              ></ng-template>
            </div>
            @if (!hideRemoveButton) {
              <button
                class="material-icons mx-4"
                mat-icon-button
                type="button"
                [attr.aria-label]="'list-item-template-remove'"
                [matTooltip]="removeButtonTooltip"
                (click)="removeClick($event, index)"
                color="warn"
              >
                delete_outline
              </button>
            }
          </div>
        </mat-expansion-panel-header>
        <ng-template
          [ngTemplateOutlet]="itemTemplateRef"
          [ngTemplateOutletContext]="{ $implicit: item }"
        ></ng-template>
      </mat-expansion-panel>
    }
  </mat-accordion>
} @else {
  @for (
    item of itemList.controls;
    track item;
    let index = $index;
    let isLast = $last
  ) {
    <div
      class="flex justify-between ml-2"
      [ngClass]="{
        '!border-l-2 !border-red-500 pl-1': itemList.at(index).invalid,
        'items-center': removeButtonPosition === 'center',
        'items-start': removeButtonPosition === 'top',
      }"
    >
      <div class="w-full">
        <ng-template
          [ngTemplateOutlet]="itemTemplateRef"
          [ngTemplateOutletContext]="{
            $implicit: item,
          }"
        ></ng-template>
      </div>
      @if (!hideRemoveButton) {
        <button
          mat-icon-button
          class="material-icons"
          type="button"
          [attr.aria-label]="'list-item-template-remove'"
          [matTooltip]="removeButtonTooltip"
          (click)="removeClick($event, index)"
          color="warn"
        >
          remove_circle_outline
        </button>
      }
    </div>
    @if (showItemDividers && !isLast) {
      <div
        class="my-6 border-b border-gray-300 dark:border-gray-600"
        data-testid="list-item-divider"
        aria-hidden="true"
      ></div>
    }
  }
}

<!-- Bottom Add Button -->
@if (!hideAddButton) {
  <div
    class="flex justify-center items-center mb-4"
    [attr.aria-label]="'list-item-template-save'"
    [ngClass]="{
      'mt-4': expandable,
      'mt-8': addButtonTopMargin,
    }"
  >
    <button
      type="button"
      (click)="handleAddItem()"
      color="primary"
      matButton="filled"
    >
      Add item
    </button>
  </div>
}
